import { Component, OnInit, OnChanges, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { MonitoringService } from '@services/monitoring.service';
import { MonitoringFilters } from '@classes/monitoring/monitoring-filters';
import { MonitoringResults } from '@classes/monitoring/monitoring-results';

@Component({
  selector: 'app-monitoring-results',
  templateUrl: './monitoring-results.component.html',
  styleUrls: ['./monitoring-results.component.scss']
})
export class MonitoringResultsComponent implements OnInit, OnChanges, OnDestroy {

    @Input() filters: MonitoringFilters;
    @Input() results: MonitoringResults;

    isExporting = false;

    lastfilters: MonitoringFilters

    private xlsSubscription:  Subscription;
    private pptSubscription: Subscription;

    constructor (private monitoringService: MonitoringService) {}

    ngOnInit (): void {
        this.pptSubscription = this.monitoringService.printModeChanged
            .subscribe(printMode => {
                this.isExporting = printMode;
            });
    }
    ngOnChanges (): void {
        this.lastfilters = this.filters.clone();
    }

    ngOnDestroy (): void {
        this.xlsSubscription?.unsubscribe();
        this.pptSubscription?.unsubscribe();
    }

    onExportXLS () {
        this.isExporting = true;
        this.xlsSubscription = this.monitoringService
            .generateXLS(this.lastfilters)
            .subscribe(() => {
                this.isExporting = false;
            });
    }
    onExportPPT () {
        this.isExporting = true;
        setTimeout(() => {
            this.monitoringService.uploadImages(this.results);
        }, 2000);
    }

}
